
import { DecimalConfig } from "@/models/dossier-configs/decimal-config";
import {Product} from "@/models/base";
import { DossierConfigService } from "@/services/dossier-config-service";
import { IGetProductTotals, ProductRow, ProductTotal } from "@/utils/product-row";
import Vue from "vue";
import { UserConfigService } from "../../services/user-config-service";

export default Vue.extend({
	props: {
		selectedRow: Object as () => ProductRow,
		totalable: Object as () => IGetProductTotals,
		product: Object as () => Product,
		toggleProfit: Boolean,
	},
	computed: {
		shouldShowProfit(): Boolean {
			if (!UserConfigService.hasCurrentUserPermission(p=>p.CanReadProductPurchaseDetails)){
				return false;
			}
			return this.toggleProfit;
		},
		item(): ProductTotal {
			return this.totalable.getProductTotals();
		},
		totalNetto(): number {
			return this.item.TotalExcVAT/(this.item.CurrencyRate ? this.item.CurrencyRate : 1) ;
		},
		vat(): number {
			return this.item.TotalVAT/(this.item.CurrencyRate ? this.item.CurrencyRate : 1);
		},
		total(): number {
			return this.item.TotalIncVAT/(this.item.CurrencyRate ? this.item.CurrencyRate : 1) + this.totalLeeggoed;
		},
		totalLeeggoed(): number {
			return this.item.TotalLeeggoed;
		},
		selectedUnitBuyPrice(): number {
			if (!this.selectedRow) return 0;
			return this.selectedRow.UnitBuyPrice || 0;
		},
		selectedProfit(): number {
			if (!this.selectedRow) return 0;
			let totalLoss = this.selectedUnitBuyPrice * this.selectedRow.Amount;
			let totalWithoutDiscount = this.selectedRow.Amount * this.selectedRow.UnitPrice;
			let total = totalWithoutDiscount - (totalWithoutDiscount * (this.selectedRow.Discount / 100));
			return total - totalLoss;
		},
		totalProfit(): number {
			let total = 0;
			for (let row of this.item.rows) {
				let amount = row.Amount;
				let loss = (row.UnitBuyPrice || 0) * amount;
				let totalSellPriceWithoutDiscount = amount * row.UnitPrice;
				let totalDiscount = totalSellPriceWithoutDiscount * (row.Discount / 100);
				let totalSellPrice = totalSellPriceWithoutDiscount - totalDiscount;
				total += totalSellPrice - loss;
			}
			return total;
		},
		decimalSettings():DecimalConfig {
			return DossierConfigService.getDecimalSettings();
		}
	},
	i18nEx: {
		componentPrefix: "components.products-table"
	}
});
